export const LAST_ACTIVE_CONVERSATION_KEY =
  'ai-assistant.lastActiveConversationId';
export const CONVERSATION_MODES_STORAGE_KEY = 'ai-assistant-conversation-modes';
